import { useMemo } from "react";
import first from "lodash/first";

import useSearchFilter from "modules/hooks/use-search-filter";

const useFilterForSelectedState = () => {
  const { searchFilters } = useSearchFilter();

  return useMemo(() => {
    const firstFilter = first(searchFilters);

    if (!firstFilter) {
      return undefined;
    }

    const id = firstFilter.objectIdListValue?.length
      ? firstFilter.objectIdListValue[0]
      : undefined;

    return {
      type: firstFilter.type,
      id,
    };
  }, [searchFilters]);
};

export default useFilterForSelectedState;
